/**
 * Airports by IATA code: [code, city, airport name, country]. Carried over from v1
 * (js/airports.js), with duplicate codes removed. Turkish names, as agents use them.
 */
export const AIRPORTS: readonly (readonly [string, string, string, string])[] = [
  ['IST', 'İstanbul', 'İstanbul Havalimanı', 'TR'],
  ['SAW', 'İstanbul', 'Sabiha Gökçen', 'TR'],
  ['ESB', 'Ankara', 'Esenboğa', 'TR'],
  ['ADB', 'İzmir', 'Adnan Menderes', 'TR'],
  ['AYT', 'Antalya', 'Antalya Havalimanı', 'TR'],
  ['DLM', 'Dalaman', 'Dalaman Havalimanı', 'TR'],
  ['BJV', 'Bodrum', 'Milas-Bodrum', 'TR'],
  ['TZX', 'Trabzon', 'Trabzon Havalimanı', 'TR'],
  ['GZT', 'Gaziantep', 'Oğuzeli', 'TR'],
  ['ADA', 'Adana', 'Şakirpaşa', 'TR'],
  ['VAN', 'Van', 'Ferit Melen', 'TR'],
  ['ERZ', 'Erzurum', 'Erzurum Havalimanı', 'TR'],
  ['DIY', 'Diyarbakır', 'Diyarbakır Havalimanı', 'TR'],
  ['KYA', 'Konya', 'Konya Havalimanı', 'TR'],
  ['MLX', 'Malatya', 'Erhaç', 'TR'],
  ['SZF', 'Samsun', 'Çarşamba', 'TR'],
  ['ASR', 'Kayseri', 'Erkilet', 'TR'],
  ['GNY', 'Şanlıurfa', 'GAP', 'TR'],
  ['HTY', 'Hatay', 'Hatay Havalimanı', 'TR'],
  ['MZH', 'Merzifon', 'Merzifon Havalimanı', 'TR'],
  ['ERC', 'Erzincan', 'Erzincan Havalimanı', 'TR'],
  ['OGU', 'Ordu-Giresun', 'Ordu-Giresun', 'TR'],
  ['NOP', 'Sinop', 'Sinop Havalimanı', 'TR'],
  ['BAL', 'Batman', 'Batman Havalimanı', 'TR'],
  ['SXZ', 'Siirt', 'Siirt Havalimanı', 'TR'],
  ['IGD', 'Iğdır', 'Iğdır Havalimanı', 'TR'],
  ['KSY', 'Kars', 'Harakani', 'TR'],
  ['MQM', 'Mardin', 'Mardin Havalimanı', 'TR'],
  ['MSR', 'Muş', 'Muş Havalimanı', 'TR'],
  ['NKT', 'Şırnak', 'Şerafettin Elçi', 'TR'],
  ['TJK', 'Tokat', 'Tokat Havalimanı', 'TR'],
  ['KCM', 'Kahramanmaraş', 'Kahramanmaraş', 'TR'],
  ['AFY', 'Afyon', 'Afyon Havalimanı', 'TR'],
  ['DNZ', 'Denizli', 'Çardak', 'TR'],
  ['NAV', 'Nevşehir', 'Kapadokya', 'TR'],
  ['AOE', 'Eskişehir', 'Anadolu', 'TR'],
  ['CKZ', 'Çanakkale', 'Çanakkale Havalimanı', 'TR'],
  ['BZI', 'Balıkesir', 'Balıkesir Merkez', 'TR'],
  ['EDO', 'Balıkesir', 'Edremit Koca Seyit', 'TR'],
  ['USQ', 'Uşak', 'Uşak Havalimanı', 'TR'],
  ['TEQ', 'Tekirdağ', 'Çorlu', 'TR'],
  ['BDM', 'Bandırma', 'Bandırma Havalimanı', 'TR'],
  ['KZR', 'Zonguldak', 'Zonguldak Havalimanı', 'TR'],
  ['SIC', 'Sinop', 'Sinop Havalimanı', 'TR'],
  ['YEI', 'Bursa', 'Yenişehir', 'TR'],
  ['ISE', 'Isparta', 'Süleyman Demirel', 'TR'],
  ['AJI', 'Ağrı', 'Ahmed-i Hani', 'TR'],
  ['BGG', 'Bingöl', 'Bingöl Havalimanı', 'TR'],
  ['HDM', 'Hakkari', 'Yüksekova Selahaddin Eyyubi', 'TR'],
  ['GKD', 'Gökçeada', 'Gökçeada Havalimanı', 'TR'],
  ['KFS', 'Kastamonu', 'Kastamonu Havalimanı', 'TR'],
  ['ONQ', 'Zonguldak', 'Çaycuma', 'TR'],
  ['SFQ', 'Şanlıurfa', 'Şanlıurfa Havalimanı', 'TR'],
  ['GZP', 'Rize', 'Rize-Artvin', 'TR'],
  ['LHR', 'Londra', 'Heathrow', 'GB'],
  ['LGW', 'Londra', 'Gatwick', 'GB'],
  ['STN', 'Londra', 'Stansted', 'GB'],
  ['LTN', 'Londra', 'Luton', 'GB'],
  ['LCY', 'Londra', 'City Airport', 'GB'],
  ['SEN', 'Londra', 'Southend', 'GB'],
  ['MAN', 'Manchester', 'Manchester', 'GB'],
  ['EDI', 'Edinburgh', 'Edinburgh', 'GB'],
  ['BHX', 'Birmingham', 'Birmingham', 'GB'],
  ['GLA', 'Glasgow', 'Glasgow', 'GB'],
  ['BRS', 'Bristol', 'Bristol', 'GB'],
  ['LPL', 'Liverpool', 'John Lennon', 'GB'],
  ['NCL', 'Newcastle', 'Newcastle', 'GB'],
  ['EMA', 'East Midlands', 'East Midlands', 'GB'],
  ['LBA', 'Leeds', 'Leeds Bradford', 'GB'],
  ['ABZ', 'Aberdeen', 'Aberdeen', 'GB'],
  ['BFS', 'Belfast', 'Belfast International', 'GB'],
  ['BHD', 'Belfast', 'Belfast City', 'GB'],
  ['CWL', 'Cardiff', 'Cardiff', 'GB'],
  ['SOU', 'Southampton', 'Southampton', 'GB'],
  ['INV', 'Inverness', 'Inverness', 'GB'],
  ['JER', 'Jersey', 'Jersey', 'GB'],
  ['CDG', 'Paris', 'Charles de Gaulle', 'FR'],
  ['ORY', 'Paris', 'Orly', 'FR'],
  ['NCE', 'Nice', "Côte d'Azur", 'FR'],
  ['LYS', 'Lyon', 'Saint-Exupéry', 'FR'],
  ['MRS', 'Marsilya', 'Provence', 'FR'],
  ['TLS', 'Toulouse', 'Toulouse-Blagnac', 'FR'],
  ['BOD', 'Bordeaux', 'Bordeaux-Mérignac', 'FR'],
  ['NTE', 'Nantes', 'Nantes Atlantique', 'FR'],
  ['SXB', 'Strasbourg', 'Strasbourg', 'FR'],
  ['MPL', 'Montpellier', 'Montpellier', 'FR'],
  ['LIL', 'Lille', 'Lille-Lesquin', 'FR'],
  ['BIQ', 'Biarritz', 'Biarritz', 'FR'],
  ['AJA', 'Ajaccio', 'Napoleon Bonaparte', 'FR'],
  ['BIA', 'Bastia', 'Bastia-Poretta', 'FR'],
  ['CFE', 'Clermont-Ferrand', 'Clermont-Ferrand', 'FR'],
  ['RNS', 'Rennes', 'Rennes-Saint-Jacques', 'FR'],
  ['BES', 'Brest', 'Brest Bretagne', 'FR'],
  ['PGF', 'Perpignan', 'Perpignan', 'FR'],
  ['FSC', 'Figari', 'Figari Sud-Corse', 'FR'],
  ['FRA', 'Frankfurt', 'Frankfurt', 'DE'],
  ['MUC', 'Münih', 'Franz Josef Strauss', 'DE'],
  ['BER', 'Berlin', 'Brandenburg', 'DE'],
  ['DUS', 'Düsseldorf', 'Düsseldorf', 'DE'],
  ['HAM', 'Hamburg', 'Hamburg', 'DE'],
  ['CGN', 'Köln', 'Köln/Bonn', 'DE'],
  ['STR', 'Stuttgart', 'Stuttgart', 'DE'],
  ['HAJ', 'Hannover', 'Hannover', 'DE'],
  ['NUE', 'Nürnberg', 'Nürnberg', 'DE'],
  ['LEJ', 'Leipzig', 'Leipzig/Halle', 'DE'],
  ['BRE', 'Bremen', 'Bremen', 'DE'],
  ['DTM', 'Dortmund', 'Dortmund', 'DE'],
  ['FMO', 'Münster', 'Münster/Osnabrück', 'DE'],
  ['PAD', 'Paderborn', 'Paderborn/Lippstadt', 'DE'],
  ['DRS', 'Dresden', 'Dresden', 'DE'],
  ['SCN', 'Saarbrücken', 'Saarbrücken', 'DE'],
  ['FKB', 'Karlsruhe', 'Baden-Baden', 'DE'],
  ['HHN', 'Hahn', 'Frankfurt-Hahn', 'DE'],
  ['FDH', 'Friedrichshafen', 'Friedrichshafen', 'DE'],
  ['MMX', 'Malmö', 'Malmö Sturup', 'SE'],
  ['ERF', 'Erfurt', 'Erfurt-Weimar', 'DE'],
  ['RLG', 'Rostock', 'Rostock-Laage', 'DE'],
  ['MAD', 'Madrid', 'Barajas', 'ES'],
  ['BCN', 'Barcelona', 'El Prat', 'ES'],
  ['AGP', 'Malaga', 'Malaga-Costa del Sol', 'ES'],
  ['PMI', 'Palma de Mallorca', 'Son Sant Joan', 'ES'],
  ['ALC', 'Alicante', 'Alicante-Elche', 'ES'],
  ['VLC', 'Valencia', 'Valencia', 'ES'],
  ['SVQ', 'Sevilla', 'San Pablo', 'ES'],
  ['BIO', 'Bilbao', 'Bilbao', 'ES'],
  ['TFS', 'Tenerife', 'Tenerife South', 'ES'],
  ['TFN', 'Tenerife', 'Tenerife North', 'ES'],
  ['LPA', 'Las Palmas', 'Gran Canaria', 'ES'],
  ['ACE', 'Lanzarote', 'Lanzarote', 'ES'],
  ['FUE', 'Fuerteventura', 'Fuerteventura', 'ES'],
  ['IBZ', 'İbiza', 'İbiza', 'ES'],
  ['MAH', 'Menorca', 'Menorca', 'ES'],
  ['GRX', 'Granada', 'Granada', 'ES'],
  ['SDR', 'Santander', 'Santander', 'ES'],
  ['OVD', 'Asturias', 'Asturias', 'ES'],
  ['SCQ', 'Santiago de Compostela', 'Santiago', 'ES'],
  ['LCG', 'A Coruña', 'Alvedro', 'ES'],
  ['VGO', 'Vigo', 'Vigo', 'ES'],
  ['MJV', 'Murcia', 'Murcia-San Javier', 'ES'],
  ['REU', 'Reus', 'Reus', 'ES'],
  ['GRO', 'Girona', 'Girona-Costa Brava', 'ES'],
  ['LEI', 'Almería', 'Almería', 'ES'],
  ['XRY', 'Jerez', 'Jerez', 'ES'],
  ['ZAZ', 'Zaragoza', 'Zaragoza', 'ES'],
  ['VLL', 'Valladolid', 'Valladolid', 'ES'],
  ['SPC', 'Santa Cruz de La Palma', 'La Palma', 'ES'],
  ['FCO', 'Roma', 'Fiumicino', 'IT'],
  ['CIA', 'Roma', 'Ciampino', 'IT'],
  ['MXP', 'Milano', 'Malpensa', 'IT'],
  ['LIN', 'Milano', 'Linate', 'IT'],
  ['BGY', 'Milano', 'Bergamo-Orio al Serio', 'IT'],
  ['VCE', 'Venedik', 'Marco Polo', 'IT'],
  ['TSF', 'Venedik', 'Treviso', 'IT'],
  ['NAP', 'Napoli', 'Capodichino', 'IT'],
  ['BLQ', 'Bologna', 'Guglielmo Marconi', 'IT'],
  ['FLR', 'Floransa', 'Peretola', 'IT'],
  ['PSA', 'Pisa', 'Galileo Galilei', 'IT'],
  ['CTA', 'Catania', 'Fontanarossa', 'IT'],
  ['PMO', 'Palermo', 'Falcone Borsellino', 'IT'],
  ['CAG', 'Cagliari', 'Elmas', 'IT'],
  ['OLB', 'Olbia', 'Costa Smeralda', 'IT'],
  ['AHO', 'Alghero', 'Fertilia', 'IT'],
  ['BRI', 'Bari', 'Karol Wojtyla', 'IT'],
  ['BDS', 'Brindisi', 'Casale', 'IT'],
  ['TRN', 'Torino', 'Caselle', 'IT'],
  ['VRN', 'Verona', 'Villafranca', 'IT'],
  ['TRS', 'Trieste', 'Ronchi dei Legionari', 'IT'],
  ['GOA', 'Cenova', 'Genova', 'IT'],
  ['SUF', 'Lamezia Terme', 'Lamezia Terme', 'IT'],
  ['REG', 'Reggio Calabria', 'Reggio Calabria', 'IT'],
  ['TPS', 'Trapani', 'Trapani-Birgi', 'IT'],
  ['CRV', 'Crotone', 'Crotone', 'IT'],
  ['PEG', 'Perugia', 'San Francesco', 'IT'],
  ['AOI', 'Ancona', 'Ancona-Falconara', 'IT'],
  ['LMP', 'Lampedusa', 'Lampedusa', 'IT'],
  ['PNL', 'Pantelleria', 'Pantelleria', 'IT'],
  ['AMS', 'Amsterdam', 'Schiphol', 'NL'],
  ['EIN', 'Eindhoven', 'Eindhoven', 'NL'],
  ['RTM', 'Rotterdam', 'Rotterdam The Hague', 'NL'],
  ['MST', 'Maastricht', 'Maastricht Aachen', 'NL'],
  ['GRQ', 'Groningen', 'Groningen Eelde', 'NL'],
  ['BRU', 'Brüksel', 'Brüksel', 'BE'],
  ['CRL', 'Brüksel', 'Charleroi', 'BE'],
  ['ANR', 'Antwerp', 'Antwerp', 'BE'],
  ['LGG', 'Liège', 'Liège', 'BE'],
  ['OST', 'Ostend', 'Ostend-Bruges', 'BE'],
  ['ZRH', 'Zürih', 'Zürich', 'CH'],
  ['GVA', 'Cenevre', 'Genève', 'CH'],
  ['BSL', 'Basel', 'EuroAirport Basel-Mulhouse', 'CH'],
  ['BRN', 'Bern', 'Bern', 'CH'],
  ['LUG', 'Lugano', 'Lugano', 'CH'],
  ['VIE', 'Viyana', 'Schwechat', 'AT'],
  ['SZG', 'Salzburg', 'Salzburg', 'AT'],
  ['INN', 'Innsbruck', 'Innsbruck', 'AT'],
  ['GRZ', 'Graz', 'Graz', 'AT'],
  ['LNZ', 'Linz', 'Blue Danube', 'AT'],
  ['KLU', 'Klagenfurt', 'Klagenfurt', 'AT'],
  ['LIS', 'Lizbon', 'Portela', 'PT'],
  ['OPO', 'Porto', 'Francisco Sá Carneiro', 'PT'],
  ['FAO', 'Faro', 'Faro', 'PT'],
  ['FNC', 'Funchal', 'Madeira', 'PT'],
  ['PDL', 'Ponta Delgada', 'João Paulo II', 'PT'],
  ['TER', 'Terceira', 'Lajes', 'PT'],
  ['HOR', 'Horta', 'Horta', 'PT'],
  ['ATH', 'Atina', 'Eleftherios Venizelos', 'GR'],
  ['SKG', 'Selanik', 'Makedonia', 'GR'],
  ['HER', 'Heraklion', 'Nikos Kazantzakis', 'GR'],
  ['RHO', 'Rodos', 'Diagoras', 'GR'],
  ['CFU', 'Korfu', 'Ioannis Kapodistrias', 'GR'],
  ['CHQ', 'Hanya', 'Ioannis Daskalogiannis', 'GR'],
  ['KGS', 'Kos', 'Hippocrates', 'GR'],
  ['JMK', 'Mikonos', 'Mykonos', 'GR'],
  ['JTR', 'Santorini', 'Santorini', 'GR'],
  ['ZTH', 'Zakynthos', 'Zakynthos', 'GR'],
  ['EFL', 'Kefalonia', 'Kefalonia', 'GR'],
  ['PVK', 'Preveza', 'Aktion', 'GR'],
  ['JKH', 'Chios', 'Chios', 'GR'],
  ['SMI', 'Samos', 'Samos', 'GR'],
  ['JSI', 'Skiathos', 'Skiathos', 'GR'],
  ['KVA', 'Kavala', 'Megas Alexandros', 'GR'],
  ['MJT', 'Midilli', 'Mytilene', 'GR'],
  ['VOL', 'Volos', 'Nea Anchialos', 'GR'],
  ['IOA', 'Ioannina', 'Ioannina', 'GR'],
  ['KLX', 'Kalamata', 'Kalamata', 'GR'],
  ['LRS', 'Leros', 'Leros', 'GR'],
  ['JNX', 'Naxos', 'Naxos', 'GR'],
  ['SPJ', 'Paros', 'Paros', 'GR'],
  ['SKU', 'Skyros', 'Skyros', 'GR'],
  ['GPA', 'Patras', 'Araxos', 'GR'],
  ['ZAG', 'Zagreb', 'Franjo Tuđman', 'HR'],
  ['SPU', 'Split', 'Split', 'HR'],
  ['DBV', 'Dubrovnik', 'Dubrovnik', 'HR'],
  ['PUY', 'Pula', 'Pula', 'HR'],
  ['ZAD', 'Zadar', 'Zadar', 'HR'],
  ['RJK', 'Rijeka', 'Rijeka', 'HR'],
  ['BWK', 'Brač', 'Brač', 'HR'],
  ['OSI', 'Osijek', 'Osijek', 'HR'],
  ['WAW', 'Varşova', 'Chopin', 'PL'],
  ['KRK', 'Krakow', 'John Paul II', 'PL'],
  ['WRO', 'Wroclaw', 'Copernicus', 'PL'],
  ['GDN', 'Gdansk', 'Lech Walesa', 'PL'],
  ['KTW', 'Katowice', 'Pyrzowice', 'PL'],
  ['POZ', 'Poznan', 'Lawica', 'PL'],
  ['RZE', 'Rzeszow', 'Jasionka', 'PL'],
  ['WMI', 'Varşova', 'Modlin', 'PL'],
  ['LUZ', 'Lublin', 'Lublin', 'PL'],
  ['SZZ', 'Szczecin', 'Goleniow', 'PL'],
  ['BZG', 'Bydgoszcz', 'Bydgoszcz', 'PL'],
  ['LCJ', 'Lodz', 'Wladyslaw Reymont', 'PL'],
  ['PRG', 'Prag', 'Václav Havel', 'CZ'],
  ['BRQ', 'Brno', 'Brno-Tuřany', 'CZ'],
  ['OSR', 'Ostrava', 'Leoš Janáček', 'CZ'],
  ['BUD', 'Budapeşte', 'Liszt Ferenc', 'HU'],
  ['DEB', 'Debrecen', 'Debrecen', 'HU'],
  ['OTP', 'Bükreş', 'Henri Coandă', 'RO'],
  ['CLJ', 'Cluj-Napoca', 'Cluj-Napoca', 'RO'],
  ['TSR', 'Timişoara', 'Timişoara', 'RO'],
  ['IAS', 'Iaşi', 'Iaşi', 'RO'],
  ['SBZ', 'Sibiu', 'Sibiu', 'RO'],
  ['BCM', 'Bacău', 'George Enescu', 'RO'],
  ['SUJ', 'Satu Mare', 'Satu Mare', 'RO'],
  ['CRA', 'Craiova', 'Craiova', 'RO'],
  ['OMR', 'Oradea', 'Oradea', 'RO'],
  ['TGM', 'Târgu Mureş', 'Târgu Mureş', 'RO'],
  ['SOF', 'Sofya', 'Sofya', 'BG'],
  ['VAR', 'Varna', 'Varna', 'BG'],
  ['BOJ', 'Burgas', 'Burgas', 'BG'],
  ['PDV', 'Plovdiv', 'Plovdiv', 'BG'],
  ['BEG', 'Belgrad', 'Nikola Tesla', 'RS'],
  ['INI', 'Niš', 'Konstantin Veliki', 'RS'],
  ['TGD', 'Podgorica', 'Podgorica', 'ME'],
  ['TIV', 'Tivat', 'Tivat', 'ME'],
  ['SKP', 'Üsküp', 'Üsküp', 'MK'],
  ['OHD', 'Ohrid', 'St. Paul the Apostle', 'MK'],
  ['TIA', 'Tiran', 'Nënë Tereza', 'AL'],
  ['SJJ', 'Saraybosna', 'Saraybosna', 'BA'],
  ['TZL', 'Tuzla', 'Tuzla', 'BA'],
  ['PRN', 'Priştine', 'Adem Jashari', 'XK'],
  ['LJU', 'Ljubljana', 'Jože Pučnik', 'SI'],
  ['BTS', 'Bratislava', 'M. R. Štefánik', 'SK'],
  ['KSC', 'Košice', 'Košice', 'SK'],
  ['CPH', 'Kopenhag', 'Kastrup', 'DK'],
  ['BLL', 'Billund', 'Billund', 'DK'],
  ['AAL', 'Aalborg', 'Aalborg', 'DK'],
  ['AAR', 'Aarhus', 'Aarhus', 'DK'],
  ['ARN', 'Stockholm', 'Arlanda', 'SE'],
  ['GOT', 'Göteborg', 'Landvetter', 'SE'],
  ['NYO', 'Stockholm', 'Skavsta', 'SE'],
  ['BMA', 'Stockholm', 'Bromma', 'SE'],
  ['UME', 'Umeå', 'Umeå', 'SE'],
  ['LLA', 'Luleå', 'Kallax', 'SE'],
  ['VXO', 'Växjö', 'Småland', 'SE'],
  ['OSL', 'Oslo', 'Gardermoen', 'NO'],
  ['BGO', 'Bergen', 'Flesland', 'NO'],
  ['TRD', 'Trondheim', 'Værnes', 'NO'],
  ['SVG', 'Stavanger', 'Sola', 'NO'],
  ['TOS', 'Tromsø', 'Langnes', 'NO'],
  ['BOO', 'Bodø', 'Bodø', 'NO'],
  ['AES', 'Ålesund', 'Vigra', 'NO'],
  ['KRS', 'Kristiansand', 'Kjevik', 'NO'],
  ['HAU', 'Haugesund', 'Karmøy', 'NO'],
  ['TRF', 'Sandefjord', 'Torp', 'NO'],
  ['HEL', 'Helsinki', 'Helsinki-Vantaa', 'FI'],
  ['OUL', 'Oulu', 'Oulu', 'FI'],
  ['TMP', 'Tampere', 'Tampere-Pirkkala', 'FI'],
  ['TKU', 'Turku', 'Turku', 'FI'],
  ['RVN', 'Rovaniemi', 'Rovaniemi', 'FI'],
  ['KUO', 'Kuopio', 'Kuopio', 'FI'],
  ['JYV', 'Jyväskylä', 'Jyväskylä', 'FI'],
  ['IVL', 'Ivalo', 'Ivalo', 'FI'],
  ['KTT', 'Kittilä', 'Kittilä', 'FI'],
  ['DUB', 'Dublin', 'Dublin', 'IE'],
  ['SNN', 'Shannon', 'Shannon', 'IE'],
  ['ORK', 'Cork', 'Cork', 'IE'],
  ['KIR', 'Kerry', 'Kerry', 'IE'],
  ['NOC', 'Knock', 'Ireland West', 'IE'],
  ['KEF', 'Reykjavik', 'Keflavík', 'IS'],
  ['RKV', 'Reykjavik', 'Reykjavik', 'IS'],
  ['AEY', 'Akureyri', 'Akureyri', 'IS'],
  ['TLL', 'Tallinn', 'Lennart Meri', 'EE'],
  ['RIX', 'Riga', 'Riga', 'LV'],
  ['VNO', 'Vilnius', 'Vilnius', 'LT'],
  ['KUN', 'Kaunas', 'Kaunas', 'LT'],
  ['PLQ', 'Palanga', 'Palanga', 'LT'],
  ['KIV', 'Kişinev', 'Kişinev', 'MD'],
  ['KBP', 'Kiev', 'Boryspil', 'UA'],
  ['IEV', 'Kiev', 'Zhuliany', 'UA'],
  ['LWO', 'Lviv', 'Danylo Halytskyi', 'UA'],
  ['ODS', 'Odessa', 'Odessa', 'UA'],
  ['HRK', 'Kharkiv', 'Kharkiv', 'UA'],
  ['DNK', 'Dnipro', 'Dnipro', 'UA'],
  ['MSQ', 'Minsk', 'Minsk', 'BY'],
  ['SVO', 'Moskova', 'Şeremetyevo', 'RU'],
  ['DME', 'Moskova', 'Domodedovo', 'RU'],
  ['VKO', 'Moskova', 'Vnukovo', 'RU'],
  ['ZIA', 'Moskova', 'Jukovski', 'RU'],
  ['LED', 'St. Petersburg', 'Pulkovo', 'RU'],
  ['KZN', 'Kazan', 'Kazan', 'RU'],
  ['AER', 'Soçi', 'Soçi', 'RU'],
  ['KRR', 'Krasnodar', 'Krasnodar', 'RU'],
  ['MRV', 'Mineralnıye Vodi', 'Mineralnıye Vodi', 'RU'],
  ['ROV', 'Rostov', 'Platov', 'RU'],
  ['UFA', 'Ufa', 'Ufa', 'RU'],
  ['SVX', 'Yekaterinburg', 'Koltsovo', 'RU'],
  ['OVB', 'Novosibirsk', 'Tolmaçevo', 'RU'],
  ['KJA', 'Krasnoyarsk', 'Yemelyanovo', 'RU'],
  ['IKT', 'Irkutsk', 'Irkutsk', 'RU'],
  ['VVO', 'Vladivostok', 'Vladivostok', 'RU'],
  ['KHV', 'Habarovsk', 'Novı', 'RU'],
  ['GOJ', 'Nijni Novgorod', 'Strigino', 'RU'],
  ['SGC', 'Surgut', 'Surgut', 'RU'],
  ['TJM', 'Tümen', 'Roşçino', 'RU'],
  ['OMS', 'Omsk', 'Tsentralnı', 'RU'],
  ['PEE', 'Perm', 'Bolşoye Savino', 'RU'],
  ['KGD', 'Kaliningrad', 'Hrabrovo', 'RU'],
  ['MMK', 'Murmansk', 'Murmansk', 'RU'],
  ['ARH', 'Arkhangelsk', 'Talagi', 'RU'],
  ['AAQ', 'Anapa', 'Vitazyevo', 'RU'],
  ['GDZ', 'Gelencik', 'Gelencik', 'RU'],
  ['STW', 'Stavropol', 'Şpakovskoye', 'RU'],
  ['VOG', 'Volgograd', 'Gumrak', 'RU'],
  ['KUF', 'Samara', 'Kurumoç', 'RU'],
  ['CEK', 'Çelyabinsk', 'Balandino', 'RU'],
  ['MCX', 'Mahaçkale', 'Uytaş', 'RU'],
  ['GRV', 'Grozni', 'Grozni', 'RU'],
  ['VOZ', 'Voronej', 'Çertovitskoye', 'RU'],
  ['KEJ', 'Kemerovo', 'Kemerovo', 'RU'],
  ['BAX', 'Barnaul', 'Barnaul', 'RU'],
  ['YKS', 'Yakutsk', 'Yakutsk', 'RU'],
  ['UUS', 'Yujno-Sahalinsk', 'Hominutovo', 'RU'],
  ['PKC', 'Petropavlovsk-Kamçatski', 'Yelizovo', 'RU'],
  ['LCA', 'Larnaka', 'Larnaka', 'CY'],
  ['PFO', 'Baf', 'Baf', 'CY'],
  ['ECN', 'Lefkoşa', 'Ercan', 'CY'],
  ['MLA', 'Malta', 'Malta International', 'MT'],
  ['LUX', 'Lüksemburg', 'Findel', 'LU'],
  ['GIB', 'Cebelitarık', 'Gibraltar', 'GI'],
  ['DXB', 'Dubai', 'Dubai International', 'AE'],
  ['AUH', 'Abu Dhabi', 'Zayed International', 'AE'],
  ['SHJ', 'Sharjah', 'Sharjah', 'AE'],
  ['DWC', 'Dubai', 'Al Maktoum', 'AE'],
  ['RKT', 'Ras al-Khaimah', 'Ras al-Khaimah', 'AE'],
  ['DOH', 'Doha', 'Hamad International', 'QA'],
  ['RUH', 'Riyad', 'King Khalid', 'SA'],
  ['JED', 'Cidde', 'King Abdulaziz', 'SA'],
  ['MED', 'Medine', 'Prince Mohammad', 'SA'],
  ['DMM', 'Dammam', 'King Fahd', 'SA'],
  ['AHB', 'Abha', 'Abha', 'SA'],
  ['TIF', 'Taif', 'Taif', 'SA'],
  ['TUU', 'Tabuk', 'Tabuk', 'SA'],
  ['GIZ', 'Jizan', 'Jizan', 'SA'],
  ['ELQ', 'Qassim', 'Qassim', 'SA'],
  ['HAS', 'Hail', 'Hail', 'SA'],
  ['YNB', 'Yanbu', 'Yanbu', 'SA'],
  ['BAH', 'Bahreyn', 'Bahrain International', 'BH'],
  ['KWI', 'Kuveyt', 'Kuwait International', 'KW'],
  ['MCT', 'Muscat', 'Muscat International', 'OM'],
  ['SLL', 'Salalah', 'Salalah', 'OM'],
  ['AMM', 'Amman', 'Queen Alia', 'JO'],
  ['AQJ', 'Aqaba', 'King Hussein', 'JO'],
  ['BEY', 'Beyrut', 'Rafic Hariri', 'LB'],
  ['TLV', 'Tel Aviv', 'Ben Gurion', 'IL'],
  ['BGW', 'Bağdat', 'Baghdad International', 'IQ'],
  ['EBL', 'Erbil', 'Erbil International', 'IQ'],
  ['NJF', 'Necef', 'Al Najaf', 'IQ'],
  ['BSR', 'Basra', 'Basra International', 'IQ'],
  ['ISU', 'Süleymaniye', 'Sulaymaniyah', 'IQ'],
  ['IKA', 'Tahran', 'Imam Khomeini', 'IR'],
  ['THR', 'Tahran', 'Mehrabad', 'IR'],
  ['MHD', 'Meşhed', 'Mashhad International', 'IR'],
  ['IFN', 'Isfahan', 'Isfahan', 'IR'],
  ['SYZ', 'Şiraz', 'Shiraz', 'IR'],
  ['TBZ', 'Tebriz', 'Tabriz', 'IR'],
  ['KIH', 'Kish Island', 'Kish', 'IR'],
  ['AWZ', 'Ahvaz', 'Ahvaz', 'IR'],
  ['ADE', 'Aden', 'Aden', 'YE'],
  ['SAH', 'Sana', "Sana'a", 'YE'],
  ['CAI', 'Kahire', 'Cairo International', 'EG'],
  ['HRG', 'Hurghada', 'Hurghada International', 'EG'],
  ['SSH', 'Sharm el-Sheikh', 'Sharm el-Sheikh', 'EG'],
  ['LXR', 'Luksor', 'Luxor', 'EG'],
  ['ASW', 'Asvan', 'Aswan', 'EG'],
  ['HBE', 'İskenderiye', 'Borg El Arab', 'EG'],
  ['RMF', 'Marsa Alam', 'Marsa Alam', 'EG'],
  ['TUN', 'Tunus', 'Tunis-Carthage', 'TN'],
  ['NBE', 'Enfidha', 'Hammamet', 'TN'],
  ['MIR', 'Monastir', 'Habib Bourguiba', 'TN'],
  ['DJE', 'Djerba', 'Djerba-Zarzis', 'TN'],
  ['SFA', 'Sfax', 'Sfax-Thyna', 'TN'],
  ['CMN', 'Kazablanka', 'Mohammed V', 'MA'],
  ['RAK', 'Marakeş', 'Menara', 'MA'],
  ['AGA', 'Agadir', 'Al Massira', 'MA'],
  ['FEZ', 'Fez', 'Saïss', 'MA'],
  ['TNG', 'Tanca', 'Ibn Battouta', 'MA'],
  ['RBA', 'Rabat', 'Rabat-Salé', 'MA'],
  ['NDR', 'Nador', 'Nador', 'MA'],
  ['OJA', 'Oujda', 'Angads', 'MA'],
  ['ESU', 'Essaouira', 'Mogador', 'MA'],
  ['ALG', 'Cezayir', 'Houari Boumediene', 'DZ'],
  ['ORN', 'Oran', 'Ahmed Ben Bella', 'DZ'],
  ['CZL', 'Constantine', 'Mohamed Boudiaf', 'DZ'],
  ['AAE', 'Annaba', 'Rabah Bitat', 'DZ'],
  ['TIP', 'Trablus', 'Tripoli International', 'LY'],
  ['MJI', 'Trablus', 'Mitiga', 'LY'],
  ['BEN', 'Bingazi', 'Benina', 'LY'],
  ['GYD', 'Bakü', 'Haydar Aliyev', 'AZ'],
  ['NAJ', 'Nahçıvan', 'Nakhchivan', 'AZ'],
  ['GNJ', 'Gence', 'Ganja', 'AZ'],
  ['TBS', 'Tiflis', 'Tiflis International', 'GE'],
  ['BUS', 'Batum', 'Batum', 'GE'],
  ['KUT', 'Kutaisi', 'David the Builder', 'GE'],
  ['EVN', 'Erivan', 'Zvartnots', 'AM'],
  ['LWN', 'Gyumri', 'Shirak', 'AM'],
  ['ALA', 'Almatı', 'Almaty International', 'KZ'],
  ['NQZ', 'Astana', 'Nursultan Nazarbayev', 'KZ'],
  ['CIT', 'Şımkent', 'Shymkent', 'KZ'],
  ['AKX', 'Aktobe', 'Aktobe', 'KZ'],
  ['SCO', 'Aktau', 'Aktau', 'KZ'],
  ['KSN', 'Kostanay', 'Kostanay', 'KZ'],
  ['URA', 'Oral', 'Oral Ak Zhol', 'KZ'],
  ['KZO', 'Kyzylorda', 'Kyzylorda', 'KZ'],
  ['GUW', 'Atyrau', 'Atyrau', 'KZ'],
  ['TAS', 'Taşkent', 'Tashkent International', 'UZ'],
  ['SKD', 'Semerkant', 'Samarkand', 'UZ'],
  ['BHK', 'Buhara', 'Bukhara', 'UZ'],
  ['NVI', 'Nevaiy', 'Navoi', 'UZ'],
  ['FEG', 'Fergana', 'Fergana', 'UZ'],
  ['UGC', 'Ürgenç', 'Urgench', 'UZ'],
  ['FRU', 'Bişkek', 'Manas International', 'KG'],
  ['OSS', 'Oş', 'Osh', 'KG'],
  ['ASB', 'Aşkabat', 'Ashgabat International', 'TM'],
  ['CRZ', 'Türkmenabat', 'Turkmenabat', 'TM'],
  ['KRW', 'Türkmenbaşı', 'Turkmenbashi', 'TM'],
  ['DYU', 'Duşanbe', 'Dushanbe', 'TJ'],
  ['LBD', 'Hucand', 'Khujand', 'TJ'],
  ['JFK', 'New York', 'John F. Kennedy', 'US'],
  ['EWR', 'New York', 'Newark Liberty', 'US'],
  ['LGA', 'New York', 'LaGuardia', 'US'],
  ['LAX', 'Los Angeles', 'LAX', 'US'],
  ['ORD', 'Chicago', "O'Hare", 'US'],
  ['MDW', 'Chicago', 'Midway', 'US'],
  ['MIA', 'Miami', 'Miami International', 'US'],
  ['FLL', 'Fort Lauderdale', 'Fort Lauderdale', 'US'],
  ['ATL', 'Atlanta', 'Hartsfield-Jackson', 'US'],
  ['SFO', 'San Francisco', 'SFO', 'US'],
  ['IAD', 'Washington', 'Dulles', 'US'],
  ['DCA', 'Washington', 'Reagan National', 'US'],
  ['BOS', 'Boston', 'Logan', 'US'],
  ['DFW', 'Dallas', 'DFW', 'US'],
  ['IAH', 'Houston', 'George Bush', 'US'],
  ['HOU', 'Houston', 'Hobby', 'US'],
  ['DEN', 'Denver', 'Denver International', 'US'],
  ['SEA', 'Seattle', 'Seattle-Tacoma', 'US'],
  ['LAS', 'Las Vegas', 'Harry Reid', 'US'],
  ['MCO', 'Orlando', 'Orlando International', 'US'],
  ['PHX', 'Phoenix', 'Sky Harbor', 'US'],
  ['MSP', 'Minneapolis', 'Minneapolis-St. Paul', 'US'],
  ['DTW', 'Detroit', 'Detroit Metropolitan', 'US'],
  ['CLT', 'Charlotte', 'Charlotte Douglas', 'US'],
  ['PHL', 'Philadelphia', 'Philadelphia', 'US'],
  ['BWI', 'Baltimore', 'Baltimore-Washington', 'US'],
  ['SLC', 'Salt Lake City', 'Salt Lake City', 'US'],
  ['TPA', 'Tampa', 'Tampa International', 'US'],
  ['SAN', 'San Diego', 'San Diego', 'US'],
  ['AUS', 'Austin', 'Austin-Bergstrom', 'US'],
  ['BNA', 'Nashville', 'Nashville', 'US'],
  ['RDU', 'Raleigh-Durham', 'Raleigh-Durham', 'US'],
  ['PDX', 'Portland', 'Portland', 'US'],
  ['STL', 'St. Louis', 'St. Louis Lambert', 'US'],
  ['MCI', 'Kansas City', 'Kansas City', 'US'],
  ['IND', 'Indianapolis', 'Indianapolis', 'US'],
  ['PIT', 'Pittsburgh', 'Pittsburgh', 'US'],
  ['CLE', 'Cleveland', 'Cleveland Hopkins', 'US'],
  ['CMH', 'Columbus', 'John Glenn', 'US'],
  ['SJC', 'San Jose', 'San Jose', 'US'],
  ['OAK', 'Oakland', 'Oakland', 'US'],
  ['SMF', 'Sacramento', 'Sacramento', 'US'],
  ['HNL', 'Honolulu', 'Daniel K. Inouye', 'US'],
  ['ANC', 'Anchorage', 'Ted Stevens', 'US'],
  ['MEM', 'Memphis', 'Memphis', 'US'],
  ['JAX', 'Jacksonville', 'Jacksonville', 'US'],
  ['RNO', 'Reno', 'Reno-Tahoe', 'US'],
  ['BUF', 'Buffalo', 'Buffalo Niagara', 'US'],
  ['ABQ', 'Albuquerque', 'Albuquerque', 'US'],
  ['OMA', 'Omaha', 'Eppley Airfield', 'US'],
  ['YYZ', 'Toronto', 'Pearson', 'CA'],
  ['YUL', 'Montreal', 'Trudeau', 'CA'],
  ['YVR', 'Vancouver', 'Vancouver', 'CA'],
  ['YOW', 'Ottawa', 'MacDonald-Cartier', 'CA'],
  ['YYC', 'Calgary', 'Calgary', 'CA'],
  ['YEG', 'Edmonton', 'Edmonton', 'CA'],
  ['YWG', 'Winnipeg', 'Winnipeg', 'CA'],
  ['YHZ', 'Halifax', 'Halifax Stanfield', 'CA'],
  ['YQB', 'Quebec City', 'Jean Lesage', 'CA'],
  ['YXE', 'Saskatoon', 'Saskatoon', 'CA'],
  ['YQR', 'Regina', 'Regina', 'CA'],
  ['YYJ', 'Victoria', 'Victoria', 'CA'],
  ['YXU', 'London', 'London', 'CA'],
  ['YKA', 'Kamloops', 'Kamloops', 'CA'],
  ['YQT', 'Thunder Bay', 'Thunder Bay', 'CA'],
  ['MEX', 'Mexico City', 'Benito Juárez', 'MX'],
  ['CUN', 'Cancún', 'Cancún International', 'MX'],
  ['GDL', 'Guadalajara', 'Miguel Hidalgo', 'MX'],
  ['MTY', 'Monterrey', 'General Mariano Escobedo', 'MX'],
  ['SLP', 'San Luis Potosí', 'Ponciano Arriaga', 'MX'],
  ['QRO', 'Querétaro', 'Querétaro Havalimanı', 'MX'],
  ['BJX', 'León', 'Del Bajío', 'MX'],
  ['AGU', 'Aguascalientes', 'Jesús Terán Peredo', 'MX'],
  ['SJD', 'Los Cabos', 'Los Cabos', 'MX'],
  ['PVR', 'Puerto Vallarta', 'Licenciado Gustavo Díaz Ordaz', 'MX'],
  ['TIJ', 'Tijuana', 'General Abelardo L. Rodríguez', 'MX'],
  ['MID', 'Mérida', 'Manuel Crescencio Rejón', 'MX'],
  ['ACA', 'Acapulco', 'Juan N. Álvarez', 'MX'],
  ['CZM', 'Cozumel', 'Cozumel', 'MX'],
  ['HAV', 'Havana', 'José Martí', 'CU'],
  ['VRA', 'Varadero', 'Juan Gualberto Gómez', 'CU'],
  ['SJU', 'San Juan', 'Luis Muñoz Marín', 'PR'],
  ['PUJ', 'Punta Cana', 'Punta Cana', 'DO'],
  ['SDQ', 'Santo Domingo', 'Las Américas', 'DO'],
  ['MBJ', 'Montego Bay', 'Sangster', 'JM'],
  ['KIN', 'Kingston', 'Norman Manley', 'JM'],
  ['NAS', 'Nassau', 'Lynden Pindling', 'BS'],
  ['BGI', 'Bridgetown', 'Grantley Adams', 'BB'],
  ['AUA', 'Aruba', 'Queen Beatrix', 'AW'],
  ['CUR', 'Curaçao', 'Hato', 'CW'],
  ['SXM', 'Sint Maarten', 'Princess Juliana', 'SX'],
  ['POS', 'Port of Spain', 'Piarco', 'TT'],
  ['PAP', 'Port-au-Prince', 'Toussaint Louverture', 'HT'],
  ['GCM', 'Grand Cayman', 'Owen Roberts', 'KY'],
  ['PTP', 'Pointe-à-Pitre', 'Pôle Caraïbes', 'GP'],
  ['FDF', 'Fort-de-France', 'Aimé Césaire', 'MQ'],
  ['GRU', 'São Paulo', 'Guarulhos', 'BR'],
  ['GIG', 'Rio de Janeiro', 'Galeão', 'BR'],
  ['BSB', 'Brasília', 'Presidente Juscelino Kubitschek', 'BR'],
  ['CNF', 'Belo Horizonte', 'Confins', 'BR'],
  ['SSA', 'Salvador', 'Deputado Luís Eduardo Magalhães', 'BR'],
  ['REC', 'Recife', 'Guararapes', 'BR'],
  ['CWB', 'Curitiba', 'Afonso Pena', 'BR'],
  ['POA', 'Porto Alegre', 'Salgado Filho', 'BR'],
  ['FOR', 'Fortaleza', 'Pinto Martins', 'BR'],
  ['VCP', 'Campinas', 'Viracopos', 'BR'],
  ['MAO', 'Manaus', 'Eduardo Gomes', 'BR'],
  ['FLN', 'Florianópolis', 'Hercílio Luz', 'BR'],
  ['NAT', 'Natal', 'São Gonçalo do Amarante', 'BR'],
  ['EZE', 'Buenos Aires', 'Ezeiza', 'AR'],
  ['AEP', 'Buenos Aires', 'Aeroparque Jorge Newbery', 'AR'],
  ['COR', 'Córdoba', 'Ambrosio Taravella', 'AR'],
  ['MDZ', 'Mendoza', 'El Plumerillo', 'AR'],
  ['IGR', 'Iguazú', 'Cataratas del Iguazú', 'AR'],
  ['BRC', 'Bariloche', 'San Carlos de Bariloche', 'AR'],
  ['ROS', 'Rosario', 'Islas Malvinas', 'AR'],
  ['BOG', 'Bogotá', 'El Dorado', 'CO'],
  ['MDE', 'Medellín', 'José María Córdova', 'CO'],
  ['CLO', 'Cali', 'Alfonso Bonilla Aragón', 'CO'],
  ['CTG', 'Cartagena', 'Rafael Núñez', 'CO'],
  ['BAQ', 'Barranquilla', 'Ernesto Cortissoz', 'CO'],
  ['SCL', 'Santiago', 'Arturo Merino', 'CL'],
  ['IQQ', 'Iquique', 'Diego Aracena', 'CL'],
  ['ANF', 'Antofagasta', 'Andrés Sabella', 'CL'],
  ['CCP', 'Concepción', 'Carriel Sur', 'CL'],
  ['PUQ', 'Punta Arenas', 'Carlos Ibáñez', 'CL'],
  ['LIM', 'Lima', 'Jorge Chávez', 'PE'],
  ['CUZ', 'Cusco', 'Alejandro Velasco Astete', 'PE'],
  ['AQP', 'Arequipa', 'Alfredo Rodríguez Ballón', 'PE'],
  ['UIO', 'Quito', 'Mariscal Sucre', 'EC'],
  ['GYE', 'Guayaquil', 'José Joaquín de Olmedo', 'EC'],
  ['GPS', 'Galápagos', 'Seymour', 'EC'],
  ['CCS', 'Caracas', 'Simón Bolívar', 'VE'],
  ['VVI', 'Santa Cruz', 'Viru Viru', 'BO'],
  ['LPB', 'La Paz', 'El Alto', 'BO'],
  ['ASU', 'Asunción', 'Silvio Pettirossi', 'PY'],
  ['MVD', 'Montevideo', 'Carrasco', 'UY'],
  ['GEO', 'Georgetown', 'Cheddi Jagan', 'GY'],
  ['PBM', 'Paramaribo', 'Johan Adolf Pengel', 'SR'],
  ['PEK', 'Pekin', 'Capital International', 'CN'],
  ['PKX', 'Pekin', 'Daxing', 'CN'],
  ['PVG', 'Şanghay', 'Pudong', 'CN'],
  ['SHA', 'Şanghay', 'Hongqiao', 'CN'],
  ['CAN', 'Guangzhou', 'Baiyun', 'CN'],
  ['SZX', 'Shenzhen', "Bao'an", 'CN'],
  ['CTU', 'Chengdu', 'Shuangliu', 'CN'],
  ['TFU', 'Chengdu', 'Tianfu', 'CN'],
  ['CKG', 'Chongqing', 'Jiangbei', 'CN'],
  ['KMG', 'Kunming', 'Changshui', 'CN'],
  ['XIY', "Xi'an", 'Xianyang', 'CN'],
  ['HGH', 'Hangzhou', 'Xiaoshan', 'CN'],
  ['NKG', 'Nanjing', 'Lukou', 'CN'],
  ['WUH', 'Wuhan', 'Tianhe', 'CN'],
  ['XMN', 'Xiamen', 'Gaoqi', 'CN'],
  ['TSN', 'Tianjin', 'Binhai', 'CN'],
  ['SHE', 'Shenyang', 'Taoxian', 'CN'],
  ['DLC', 'Dalian', 'Zhoushuizi', 'CN'],
  ['TAO', 'Qingdao', 'Jiaodong', 'CN'],
  ['HRB', 'Harbin', 'Taiping', 'CN'],
  ['CSX', 'Changsha', 'Huanghua', 'CN'],
  ['CGO', 'Zhengzhou', 'Xinzheng', 'CN'],
  ['NNG', 'Nanning', 'Wuxu', 'CN'],
  ['URC', 'Ürümçi', 'Diwopu', 'CN'],
  ['FOC', 'Fuzhou', 'Changle', 'CN'],
  ['KWE', 'Guiyang', 'Longdongbao', 'CN'],
  ['LHW', 'Lanzhou', 'Zhongchuan', 'CN'],
  ['HAK', 'Haikou', 'Meilan', 'CN'],
  ['SYX', 'Sanya', 'Phoenix', 'CN'],
  ['KWL', 'Guilin', 'Liangjiang', 'CN'],
  ['HKG', 'Hong Kong', 'Hong Kong International', 'HK'],
  ['MFM', 'Makao', 'Macau International', 'MO'],
  ['TPE', 'Taipei', 'Taoyuan', 'TW'],
  ['TSA', 'Taipei', 'Songshan', 'TW'],
  ['KHH', 'Kaohsiung', 'Kaohsiung', 'TW'],
  ['NRT', 'Tokyo', 'Narita', 'JP'],
  ['HND', 'Tokyo', 'Haneda', 'JP'],
  ['KIX', 'Osaka', 'Kansai', 'JP'],
  ['ITM', 'Osaka', 'Itami', 'JP'],
  ['NGO', 'Nagoya', 'Chubu Centrair', 'JP'],
  ['FUK', 'Fukuoka', 'Fukuoka', 'JP'],
  ['CTS', 'Sapporo', 'New Chitose', 'JP'],
  ['OKA', 'Okinawa', 'Naha', 'JP'],
  ['KOJ', 'Kagoshima', 'Kagoshima', 'JP'],
  ['HIJ', 'Hiroshima', 'Hiroshima', 'JP'],
  ['SDJ', 'Sendai', 'Sendai', 'JP'],
  ['KMJ', 'Kumamoto', 'Kumamoto', 'JP'],
  ['NKM', 'Nagoya', 'Komaki', 'JP'],
  ['TAK', 'Takamatsu', 'Takamatsu', 'JP'],
  ['MYJ', 'Matsuyama', 'Matsuyama', 'JP'],
  ['NGS', 'Nagasaki', 'Nagasaki', 'JP'],
  ['OIT', 'Oita', 'Oita', 'JP'],
  ['ICN', 'Seul', 'Incheon', 'KR'],
  ['GMP', 'Seul', 'Gimpo', 'KR'],
  ['PUS', 'Busan', 'Gimhae', 'KR'],
  ['CJU', 'Jeju', 'Jeju', 'KR'],
  ['TAE', 'Daegu', 'Daegu', 'KR'],
  ['SIN', 'Singapur', 'Changi', 'SG'],
  ['BKK', 'Bangkok', 'Suvarnabhumi', 'TH'],
  ['DMK', 'Bangkok', 'Don Mueang', 'TH'],
  ['HKT', 'Phuket', 'Phuket', 'TH'],
  ['CNX', 'Chiang Mai', 'Chiang Mai', 'TH'],
  ['USM', 'Koh Samui', 'Samui', 'TH'],
  ['KBV', 'Krabi', 'Krabi', 'TH'],
  ['KUL', 'Kuala Lumpur', 'KLIA', 'MY'],
  ['PEN', 'Penang', 'Penang', 'MY'],
  ['BKI', 'Kota Kinabalu', 'Kota Kinabalu', 'MY'],
  ['KCH', 'Kuching', 'Kuching', 'MY'],
  ['LGK', 'Langkawi', 'Langkawi', 'MY'],
  ['CGK', 'Cakarta', 'Soekarno-Hatta', 'ID'],
  ['DPS', 'Bali', 'Ngurah Rai', 'ID'],
  ['SUB', 'Surabaya', 'Juanda', 'ID'],
  ['JOG', 'Yogyakarta', 'Adisucipto', 'ID'],
  ['UPG', 'Makassar', 'Sultan Hasanuddin', 'ID'],
  ['MES', 'Medan', 'Kualanamu', 'ID'],
  ['MNL', 'Manila', 'Ninoy Aquino', 'PH'],
  ['CEB', 'Cebu', 'Mactan-Cebu', 'PH'],
  ['CRK', 'Clark', 'Clark', 'PH'],
  ['KLO', 'Kalibo', 'Kalibo', 'PH'],
  ['DVO', 'Davao', 'Francisco Bangoy', 'PH'],
  ['SGN', 'Ho Chi Minh', 'Tan Son Nhat', 'VN'],
  ['HAN', 'Hanoi', 'Noi Bai', 'VN'],
  ['DAD', 'Da Nang', 'Da Nang', 'VN'],
  ['CXR', 'Nha Trang', 'Cam Ranh', 'VN'],
  ['PQC', 'Phu Quoc', 'Phu Quoc', 'VN'],
  ['HPH', 'Haiphong', 'Cat Bi', 'VN'],
  ['HUI', 'Hue', 'Phu Bai', 'VN'],
  ['PNH', 'Phnom Penh', 'Phnom Penh', 'KH'],
  ['REP', 'Siem Reap', 'Angkor', 'KH'],
  ['VTE', 'Vientiane', 'Wattay', 'LA'],
  ['LPQ', 'Luang Prabang', 'Luang Prabang', 'LA'],
  ['RGN', 'Yangon', 'Yangon', 'MM'],
  ['MDL', 'Mandalay', 'Mandalay', 'MM'],
  ['BWN', 'Bandar Seri Begawan', 'Brunei', 'BN'],
  ['DEL', 'Yeni Delhi', 'Indira Gandhi', 'IN'],
  ['BOM', 'Mumbai', 'Chhatrapati Shivaji', 'IN'],
  ['BLR', 'Bangalore', 'Kempegowda', 'IN'],
  ['MAA', 'Chennai', 'Chennai', 'IN'],
  ['CCU', 'Kalküta', 'Netaji Subhas Chandra Bose', 'IN'],
  ['HYD', 'Hyderabad', 'Rajiv Gandhi', 'IN'],
  ['COK', 'Kochi', 'Cochin', 'IN'],
  ['GOI', 'Goa', 'Dabolim', 'IN'],
  ['AMD', 'Ahmedabad', 'Sardar Vallabhbhai Patel', 'IN'],
  ['JAI', 'Jaipur', 'Jaipur', 'IN'],
  ['TRV', 'Trivandrum', 'Trivandrum', 'IN'],
  ['PNQ', 'Pune', 'Pune', 'IN'],
  ['GAU', 'Guwahati', 'Lokpriya Gopinath Bordoloi', 'IN'],
  ['IXC', 'Chandigarh', 'Chandigarh', 'IN'],
  ['LKO', 'Lucknow', 'Chaudhary Charan Singh', 'IN'],
  ['CCJ', 'Kozhikode', 'Calicut', 'IN'],
  ['VNS', 'Varanasi', 'Lal Bahadur Shastri', 'IN'],
  ['ATQ', 'Amritsar', 'Sri Guru Ram Dass Jee', 'IN'],
  ['SXR', 'Srinagar', 'Sheikh ul-Alam', 'IN'],
  ['IXB', 'Bagdogra', 'Bagdogra', 'IN'],
  ['KHI', 'Karaçi', 'Jinnah International', 'PK'],
  ['ISB', 'İslamabad', 'Islamabad International', 'PK'],
  ['LHE', 'Lahor', 'Allama Iqbal', 'PK'],
  ['CMB', 'Colombo', 'Bandaranaike', 'LK'],
  ['HRI', 'Mattala', 'Mattala Rajapaksa', 'LK'],
  ['MLE', 'Malé', 'Velana International', 'MV'],
  ['KTM', 'Kathmandu', 'Tribhuvan', 'NP'],
  ['DAC', 'Dakka', 'Hazrat Shahjalal', 'BD'],
  ['CGP', 'Chittagong', 'Shah Amanat', 'BD'],
  ['UBN', 'Ulan Batur', 'Chinggis Khaan', 'MN'],
  ['SYD', 'Sidney', 'Kingsford Smith', 'AU'],
  ['MEL', 'Melbourne', 'Tullamarine', 'AU'],
  ['BNE', 'Brisbane', 'Brisbane', 'AU'],
  ['PER', 'Perth', 'Perth', 'AU'],
  ['ADL', 'Adelaide', 'Adelaide', 'AU'],
  ['CBR', 'Canberra', 'Canberra', 'AU'],
  ['OOL', 'Gold Coast', 'Gold Coast', 'AU'],
  ['CNS', 'Cairns', 'Cairns', 'AU'],
  ['HBA', 'Hobart', 'Hobart', 'AU'],
  ['DRW', 'Darwin', 'Darwin', 'AU'],
  ['TSV', 'Townsville', 'Townsville', 'AU'],
  ['NTL', 'Newcastle', 'Williamtown', 'AU'],
  ['AKL', 'Auckland', 'Auckland', 'NZ'],
  ['WLG', 'Wellington', 'Wellington', 'NZ'],
  ['CHC', 'Christchurch', 'Christchurch', 'NZ'],
  ['ZQN', 'Queenstown', 'Queenstown', 'NZ'],
  ['DUD', 'Dunedin', 'Dunedin', 'NZ'],
  ['NAN', 'Nadi', 'Nadi', 'FJ'],
  ['SUV', 'Suva', 'Nausori', 'FJ'],
  ['PPT', 'Papeete', "Faa'a", 'PF'],
  ['NOU', 'Nouméa', 'La Tontouta', 'NC'],
  ['APW', 'Apia', 'Faleolo', 'WS'],
  ['JNB', 'Johannesburg', 'O.R. Tambo', 'ZA'],
  ['CPT', 'Cape Town', 'Cape Town International', 'ZA'],
  ['DUR', 'Durban', 'King Shaka', 'ZA'],
  ['PLZ', 'Port Elizabeth', 'Chief Dawid Stuurman', 'ZA'],
  ['NBO', 'Nairobi', 'Jomo Kenyatta', 'KE'],
  ['MBA', 'Mombasa', 'Moi International', 'KE'],
  ['ADD', 'Addis Ababa', 'Bole International', 'ET'],
  ['LOS', 'Lagos', 'Murtala Muhammed', 'NG'],
  ['ABV', 'Abuja', 'Nnamdi Azikiwe', 'NG'],
  ['ACC', 'Accra', 'Kotoka International', 'GH'],
  ['DAR', 'Dar es Salaam', 'Julius Nyerere', 'TZ'],
  ['ZNZ', 'Zanzibar', 'Abeid Amani Karume', 'TZ'],
  ['JRO', 'Kilimanjaro', 'Kilimanjaro', 'TZ'],
  ['EBB', 'Kampala', 'Entebbe', 'UG'],
  ['KGL', 'Kigali', 'Kigali International', 'RW'],
  ['MPM', 'Maputo', 'Maputo International', 'MZ'],
  ['LUN', 'Lusaka', 'Kenneth Kaunda', 'ZM'],
  ['HRE', 'Harare', 'Robert Gabriel Mugabe', 'ZW'],
  ['VFA', 'Victoria Falls', 'Victoria Falls', 'ZW'],
  ['LLW', 'Lilongwe', 'Kamuzu', 'MW'],
  ['GBE', 'Gaborone', 'Sir Seretse Khama', 'BW'],
  ['WDH', 'Windhoek', 'Hosea Kutako', 'NA'],
  ['MRU', 'Mauritius', 'Sir Seewoosagur Ramgoolam', 'MU'],
  ['TNR', 'Antananarivo', 'Ivato', 'MG'],
  ['SEZ', 'Mahé', 'Seychelles', 'SC'],
  ['DKR', 'Dakar', 'Blaise Diagne', 'SN'],
  ['ABJ', 'Abidjan', 'Félix-Houphouët-Boigny', 'CI'],
  ['ROB', 'Monrovia', 'Roberts', 'LR'],
  ['FNA', 'Freetown', 'Lungi', 'SL'],
  ['BJL', 'Banjul', 'Banjul', 'GM'],
  ['BKO', 'Bamako', 'Modibo Keïta', 'ML'],
  ['OUA', 'Ouagadougou', 'Thomas Sankara', 'BF'],
  ['NIM', 'Niamey', 'Diori Hamani', 'NE'],
  ['NDJ', "N'Djamena", 'Hassan Djamous', 'TD'],
  ['DLA', 'Douala', 'Douala', 'CM'],
  ['YAO', 'Yaoundé', 'Nsimalen', 'CM'],
  ['LBV', 'Libreville', 'Léon-Mba', 'GA'],
  ['BZV', 'Brazzaville', 'Maya-Maya', 'CG'],
  ['FIH', 'Kinshasa', "N'Djili", 'CD'],
  ['BGF', 'Bangui', "Bangui M'Poko", 'CF'],
  ['SSG', 'Malabo', 'Malabo', 'GQ'],
  ['ASI', 'Georgetown', 'Wideawake', 'SH'],
  ['MQX', 'Mekelle', 'Alula Aba Nega', 'ET'],
  ['DIR', 'Dire Dawa', 'Aba Tenna Dejazmach', 'ET'],
  ['MGQ', 'Mogadişu', 'Aden Abdulle International', 'SO'],
  ['DJI', 'Cibuti', 'Ambouli', 'DJ'],
  ['ASM', 'Asmara', 'Asmara International', 'ER'],
];
